import Swiper, { Navigation, Pagination } from 'swiper';
export const init = async function() {
    const container = '.js-nosto-tabs';
    const allNostoElements = document.querySelectorAll('.js-nosto-tab-content');
    Swiper.use([
        Navigation,
        Pagination
    ]);
    const hideAllNostoElements = ()=>{
        allNostoElements.forEach((element)=>{
            if (element instanceof HTMLElement) {
                element.style.display = 'none';
            }
        });
    };
    const hideAllNostoElementsExceptFirst = ()=>{
        allNostoElements.forEach((element, index)=>{
            if (index !== 0 && element instanceof HTMLElement) {
                element.style.display = 'none';
            }
        });
    };
    if (container) {
        new Swiper(container, {
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            lazy: {
                loadPrevNext: true
            },
            slidesPerView: 1.7,
            centeredSlides: false,
            loop: false,
            spaceBetween: 12,
            breakpoints: {
                1024: {
                    slidesPerView: 4.5,
                    spaceBetween: 24
                }
            }
        });
        const buttons = document.querySelectorAll(`${container} .js-nosto-placement-trigger`);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const placementId = button.getAttribute('data-nosto-placement');
                const nostoElement = document.querySelector(`.nosto_element#${placementId}`);
                buttons.forEach((btn)=>btn.classList.remove('active-tab'));
                button.classList.add('active-tab');
                // Hide all elements first
                hideAllNostoElements();
                // Display only the clicked element
                if (nostoElement && nostoElement.parentElement) {
                    nostoElement.parentElement.style.display = 'block';
                }
            });
        });
        hideAllNostoElementsExceptFirst();
        const firstButton = buttons[0];
        if (firstButton) {
            firstButton.classList.add('active-tab');
        }
    }
};
